import Price from '/components/Price';
import PropTypes from 'prop-types';
import Typography from '/components/Typography';

import { getPackPrice } from '/services/static/packs/pack-price';
import { useEffect, useState } from 'react';

const PackPrice = ({ builderConfig, packConfig }) => {
	const [prices, setPrices] = useState({});
	const [showDiscount, setShowDiscount] = useState(false);

	useEffect(() => {
		if (!builderConfig?.builderType || !packConfig.selectedProducts) {
			return;
		}

		const prices = getPackPrice({
			builderConfig: builderConfig,
			builderId: builderConfig.id,
			builderType: builderConfig.builderType,
			selectedBox: packConfig.box,
			selectedProducts: packConfig.selectedProducts,
			selectedExtras: packConfig.selectedExtras,
		});

		setPrices(prices);

		if (prices.success === true) {
			setShowDiscount(prices.priceRetailTotal > prices.priceDiscountTotal);
		}
	}, [
		builderConfig.builderType,
		packConfig.selectedProducts,
		packConfig.box,
		packConfig.selectedExtras,
	]);

	if (prices.success !== true) {
		return null;
	}

	if (showDiscount === false) {
		return (
			<div className="flex flex-col gap-1 items-center">
				<Typography className="md:mb-2" variant="subhead-md">
					<Price format={'explicit'} price={prices.priceDiscountTotal} />
				</Typography>
			</div>
		);
	}

	return (
		<div className="flex md:flex-col gap-1 items-center">
			{/* <Typography className="line-through text-[#595959]" variant="subtitle-sm">
				<Price price={prices.priceRetailTotal} showSymbol={true} />
			</Typography> */}
			<div className="grid">
				<Typography variant="subhead-sm">
					Pack Total:{' '}
					<Price format={'explicit'} price={prices.priceDiscountTotal} showSymbol={true} />
				</Typography>

				{/* {builderConfig.hidePerPairPrice !== true && (
					<Typography component="span" variant="body">
						<span className="font-semibold">
							<Price price={prices.priceDiscountPerPair} />
						</span>{' '}
						per pair
					</Typography>
				)} */}
			</div>
			<Typography className="text-primary" component="span" variant="body">
				(Saving <Price price={prices.discountDollars} />)
			</Typography>
		</div>
	);
};

PackPrice.propTypes = {
	builderConfig: PropTypes.object,
	packConfig: PropTypes.object,
};

export default PackPrice;
